import React, { useState } from 'react';
import { Container, Draggable, DropResult } from 'react-smooth-dnd';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from '@material-ui/core';
import { Cancel, Done, Height } from '@material-ui/icons';
import arrayMove from 'array-move';
import { IServiceType } from '../../../interfaces';

interface IProps extends Omit<DialogProps, 'onClose'> {
  disabled: boolean;
  serviceTypes: IServiceType[];
  onClose(): void;
  onSave(serviceTypes: IServiceType[]): void;
}

const ReorderServiceTypes = ({ disabled, onClose, onSave, ...props }: IProps) => {
  const [serviceTypes, setServiceTypes] = useState<IServiceType[]>(props.serviceTypes || []);

  const onDrop = ({ removedIndex, addedIndex }: DropResult) => {
    setServiceTypes((prevServiceTypes: IServiceType[]) => arrayMove(prevServiceTypes, removedIndex!, addedIndex!));
  };

  return (
    <Dialog {...props} fullWidth maxWidth="sm" scroll="paper" onClose={onClose}>
      <DialogTitle>
        <b>Изменить порядок типов услуг</b>
      </DialogTitle>

      <DialogContent dividers style={{ padding: 0 }}>
        <List disablePadding>
          <Container dragHandleSelector="#drag-handle" lockAxis="y" onDrop={onDrop}>
            {serviceTypes.map((serviceType, columnsOrderIndex) => (
              <Draggable key={columnsOrderIndex}>
                <ListItem divider={columnsOrderIndex !== serviceTypes.length - 1}>
                  <ListItemText primary={serviceType.serviceTypeName} />

                  <ListItemSecondaryAction>
                    <Box id="drag-handle" style={{ cursor: 'grab' }}>
                      <Height />
                    </Box>
                  </ListItemSecondaryAction>
                </ListItem>
              </Draggable>
            ))}
          </Container>
        </List>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" disabled={disabled} onClick={onClose} startIcon={<Cancel />}>
          Отменить
        </Button>

        <Button
          color="primary"
          variant="contained"
          disabled={disabled}
          onClick={() => onSave(serviceTypes)}
          type="submit"
          startIcon={<Done />}
        >
          Обновить
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReorderServiceTypes;
